var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"8","key":0}),React.createElement("line",{"x1":"21","y1":"21","x2":"16.65","y2":"16.65","key":1})]);
}

SearchInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-search"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
